module.exports = __webpack_public_path__ + "static/media/virus-pixabay.1f81013a.png";